export default {
  root: {
    color: 'currentColor',
    minWidth: 40,
  },
};
